// src/components/buyerPersona/BuyerPersonaModal.jsx
import React, { useState } from 'react';
import BuyerPersonaQuiz from './BuyerPersonaQuiz';
import BuyerPersonaResult from './BuyerPersonaResult';

const BuyerPersonaModal = ({ isOpen, onClose, mode = 'create', existingPersona = null }) => {
    const [currentView, setCurrentView] = useState('quiz');
    const [buyerPersona, setBuyerPersona] = useState(existingPersona);

    const handleQuizComplete = (result) => {
        if (process.env.NODE_ENV === 'development') {
            console.log('Quiz completed with result:', result);
        }
        setBuyerPersona(result);
        setCurrentView('result');
    };

    const handleBackToQuiz = () => {
        setCurrentView('quiz');
    };

    const handleClose = () => {
        setCurrentView('quiz');
        setBuyerPersona(null);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="flex justify-between items-center p-6 border-b">
                    <h2 className="text-2xl font-bold text-gray-800">
                        {mode === 'create' ? 'Crear Buyer Persona' : 'Editar Buyer Persona'}
                    </h2>
                    <button
                        onClick={handleClose}
                        className="text-gray-500 hover:text-gray-700 transition-colors text-xl"
                    >
                        ✕
                    </button>
                </div>

                {/* Content */}
                <div className="p-6">
                    {currentView === 'quiz' && (
                        <BuyerPersonaQuiz
                            mode={mode}
                            existingPersona={existingPersona}
                            onComplete={handleQuizComplete}
                            onClose={handleClose}
                        />
                    )}

                    {currentView === 'result' && buyerPersona && (
                        <BuyerPersonaResult
                            result={buyerPersona}
                            onBack={handleBackToQuiz}
                            onClose={handleClose}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default BuyerPersonaModal; 